import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './cta-with-image.component.scss';
var CtaWithImage = /** @class */ (function (_super) {
    tslib_1.__extends(CtaWithImage, _super);
    function CtaWithImage(element) {
        return _super.call(this, element) || this;
    }
    CtaWithImage.prototype.init = function () {
    };
    CtaWithImage.prototype.bindEvents = function () {
    };
    return CtaWithImage;
}(Base));
export { CtaWithImage };



//////////////////
// WEBPACK FOOTER
// ./components/cta-with-image/cta-with-image.component.ts
// module id = 246
// module chunks = 0